!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports, require("react"), require("classnames"), require("@material-ui/core"), require("@material-ui/styles"), require("react-router-dom"), require("@material-ui/core/styles")) : "function" == typeof define && define.amd ? define(["exports", "react", "classnames", "@material-ui/core", "@material-ui/styles", "react-router-dom", "@material-ui/core/styles"], r) : r((e = e || self)["hover-link"] = {}, e.React, e.classNames, e.core, e.styles, e.reactRouterDom, e.styles$1);
}(this, function (e, r, t, n, o, a, i) {
  "use strict";

  r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;

  var _l = function l() {
    return (_l = Object.assign || function (e) {
      for (var r, t = 1, n = arguments.length; t < n; t++) for (var o in r = arguments[t]) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);

      return e;
    }).apply(this, arguments);
  };

  function c(e, r) {
    var t = {};

    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
    }

    return t;
  }

  var s = function s(e, r, t, n, a) {
    return o.makeStyles(function (l) {
      var c = "textPrimary" === e || "textSecondary" === e ? l.palette.text["textPrimary" === e ? "primary" : "secondary"] : l.palette[e || "primary"].main,
          s = "textPrimary" === r || "textSecondary" === r ? l.palette.text["textPrimary" === r ? "primary" : "secondary"] : l.palette[r || "primary"].main;
      return o.createStyles({
        link: {
          textDecoration: n ? "none" : t ? "underline" : "none",
          color: a ? i.fade(c, .3) : c,
          "&:hover": a ? void 0 : {
            cursor: "pointer",
            color: i.lighten(s, .3),
            textDecoration: n ? "none" : t ? "none" : "underline",
            textDecorationColor: i.lighten(s, .3)
          }
        }
      });
    })();
  };

  e.HoverLink = function (e) {
    var n = e.children,
        o = e.color,
        i = e.hoverColor,
        u = e.invertUnderlineBehaviour,
        d = e.disabled,
        p = e.disableUnderline,
        y = e.external,
        m = c(e, ["children", "color", "hoverColor", "invertUnderlineBehaviour", "disabled", "disableUnderline", "external"]),
        f = s(o || "textPrimary", i || "primary", u || !1, p || !1, d || !1);
    return y ? r.createElement("a", _l({}, m, {
      onClick: d ? function (e) {
        e.preventDefault(), e.stopPropagation();
      } : void 0,
      className: t([f.link, e.className]),
      href: m.to
    }), n) : r.createElement(a.Link, _l({}, m, {
      onClick: d ? function (e) {
        e.preventDefault(), e.stopPropagation();
      } : void 0,
      className: t([f.link, e.className])
    }), n);
  }, e.HoverText = function (e) {
    var o = e.children,
        a = e.color,
        i = e.hoverColor,
        u = e.invertUnderlineBehaviour,
        d = e.onClick,
        p = e.disabled,
        y = e.disableUnderline,
        m = c(e, ["children", "color", "hoverColor", "invertUnderlineBehaviour", "onClick", "disabled", "disableUnderline"]),
        f = s(a || "textPrimary", i || "primary", u || !1, y || !1, p || !1);
    return r.createElement(n.Typography, _l({}, m, {
      noWrap: !0,
      className: t([f.link, e.className]),
      onClick: p ? void 0 : d
    }), o);
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});